/** Shared services list — home preview + services page */
export const servicesList = [
  {
    icon: 'fas fa-graduation-cap',
    title: 'LMS Development',
    description:
      'Custom learning platforms with exams, courses, live classes, AI study plans, mobile apps, and admin panels.',
    link: '/lms',
  },
  { icon: 'fas fa-code', title: 'Website Development', description: 'Fast, responsive, SEO-ready websites that convert visitors into customers.' },
  { icon: 'fas fa-shopping-cart', title: 'E-commerce Solutions', description: 'WooCommerce & custom stores with secure payments and smooth checkout.' },
  { icon: 'fas fa-users', title: 'CRM Development', description: 'Manage leads, sales pipelines, and customer relationships in one place.' },
  { icon: 'fas fa-building', title: 'ERP Development', description: 'Inventory, HR, finance, and operations unified for growing businesses.' },
  { icon: 'fas fa-palette', title: 'UI/UX Design', description: 'Beautiful interfaces focused on usability and brand consistency.' },
  { icon: 'fas fa-bullhorn', title: 'Digital Marketing', description: 'SEO, ads, and social strategies that drive measurable growth.' },
  { icon: 'fas fa-cloud', title: 'Cloud Solutions', description: 'Scalable hosting, APIs, and cloud infrastructure on AWS & more.' },
  { icon: 'fas fa-headset', title: 'Support & Maintenance', description: 'Ongoing updates, monitoring, and dedicated technical support.' },
];
